import React from "react";
import {Loader, LoaderLight, Upload} from "~/ui/icons";
import {Button, CircularProgress} from "@mui/material";
import {Control, Controller} from "react-hook-form";
import {makeStyles} from "@mui/styles";
import {PortTheme} from "~/ui/theme";

const useStyles = makeStyles<PortTheme>((theme) => ({
    disabledButtonStyle: {
        '&.Mui-disabled': {
            backgroundColor: '#9EBBD9',
            color: "white"
        }
    },
    loadingIcon: {
        width: '24px',
        height: '24px',
        animation: "$spin 1s linear infinite",
    },

    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)",
        },
        "100%": {
            transform: "rotate(360deg)",
        },
    },
}))

type UploadFilesButtonProps = {
    onChange: (files: File[]) => void
    multiple?: boolean
    accept?: string
    name: string
    control: Control
    disabled?: boolean
    loading?: boolean
}
export const UploadFilesButton = (props: UploadFilesButtonProps) => {
    const {onChange, multiple, accept, name, control, disabled, loading} = props;
    const styles = useStyles();
    const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            onChange(Array.from(event.target.files));
        }
    }

    return (
        <>
            <Controller
                name={name}
                control={control}
                rules={{required: true}}
                render={({ onChange, value }) => <></>}
            />
            <input
                id="fileUploadInput"
                type="file"
                accept={accept}
                onChange={handleUpload}
                hidden
                multiple={multiple}
                onClick={(event)=> {
                    //@ts-ignore
                    event.target.value = null
                }}
            />
            <Button
                variant="contained"
                color="additionalPrimary"
                fullWidth
                startIcon={!loading ? <Upload /> : null}
                component="label"
                htmlFor="fileUploadInput"
                disabled={disabled}
                classes={{disabled: styles.disabledButtonStyle}}
                disableElevation={false}
            >
                {loading ? <LoaderLight className={styles.loadingIcon} />  : 'Загрузить'}
            </Button>
        </>
    )
}
